// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import {
    createElement,
    classNames,
    Button,
    Component,
    Grid,
    GridCol,
    Icon,
    List,
    LocaleProvider,
    Media,
    MediaSection,
    Panel,
    PropTypes,
    Toaster,
    Translate,
} from '@plesk/ui-library';
import Disk from './Disk';
import Memory from './Memory';
import Overview from './Overview';
import ServiceStatus from './ServiceStatus';

import locale from './locale/en-US.json';

const Services = ({ data, onRestart, isProcessing, ...props }) => (
    <Panel title={<Translate content="Services.title" />} {...props}>
        <Media image={<Icon src="images/services.png" size="lg" alt="Services" />}>
            <MediaSection>
                <Translate content="Services.description" />
            </MediaSection>
            <MediaSection>
                <List
                    columns={[{
                        key: 'name',
                        title: <Translate content="Services.name" />,
                    }, {
                        key: 'status',
                        title: <Translate content="Services.status" />,
                        render: ({ status }) => // eslint-disable-line react/display-name,react/prop-types
                            (
                                <ServiceStatus status={status} />
                            ),
                    }]}
                    rowKey="name"
                    data={data}
                />
            </MediaSection>
            <MediaSection>
                <Translate content="Services.recommend" />
            </MediaSection>
            <MediaSection>
                <Button intent="primary" onClick={onRestart} state={isProcessing ? 'loading' : null} id="services-fix">
                    <Translate content="Services.fixServices" />
                </Button>
            </MediaSection>
        </Media>
    </Panel>
);

Services.propTypes = {
    data: PropTypes.array.isRequired,
    onRestart: PropTypes.func.isRequired,
    isProcessing: PropTypes.bool.isRequired,
};

export default Services;



// WEBPACK FOOTER //
// ./app/repair/Services.js